import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Vector3 } from '@math.gl/core';
const DEFAULT_LIGHT_COLOR = [255, 255, 255];
const DEFAULT_LIGHT_INTENSITY = 1.0;
const DEFAULT_LIGHT_DIRECTION = [0.0, 0.0, -1.0];
let idCount = 0;
export class DirectionalLight {
  constructor(props = {}) {
    _defineProperty(this, "id", void 0);

    _defineProperty(this, "color", void 0);

    _defineProperty(this, "intensity", void 0);

    _defineProperty(this, "type", 'directional');

    _defineProperty(this, "direction", void 0);

    _defineProperty(this, "shadow", void 0);

    const {
      color = DEFAULT_LIGHT_COLOR
    } = props;
    const {
      intensity = DEFAULT_LIGHT_INTENSITY
    } = props;
    const {
      direction = DEFAULT_LIGHT_DIRECTION
    } = props;
    const {
      _shadow = false
    } = props;
    this.id = props.id || "directional-".concat(idCount++);
    this.color = color;
    this.intensity = intensity;
    this.type = 'directional';
    this.direction = new Vector3(direction).normalize().toArray();
    this.shadow = _shadow;
  }

  getProjectedLight(opts) {
    return this;
  }

}
//# sourceMappingURL=directional-light.js.map